import React, {Component} from 'react';
import {Form} from 'antd';
import config from 'src/commons/config-hoc';
import {FormElement, ModalContent} from 'src/library/components';
import PageContent from 'src/layouts/page-content';
import { post } from '../../../utils/axios_utils'
import {validateStrongPassword} from 'src/utils/password_utils';
@config({
    ajax: true,
    connect: state => ({loginUser: state.system.loginUser}),
    modal: {
        title: '修改密码',
        width: 420,
        centered: true,
    },
})
export default class ModifyPassword extends Component {
    state = {
        loading: false,
    };

    handleOk = (values) => {
        if (this.state.loading) return;
        this.setState({ loading: true })
        let params = {
            newPassword: values.newPassword,
            oldPassword: values.oldPassword,
        }
        post('/system/user/change_password', params, '修改成功')
            .then(res => {
                if (res.status === 'success') {
                    const {onOk} = this.props;
                    onOk && onOk();
                }
            }).catch(err => {
            console.log(err);
        }).finally(() => this.setState({loading: false}));
    };

    handleCancel = () => {
        const {onCancel} = this.props;
        if (onCancel) onCancel();
    };

    render() {
        const {loginUser} = this.props;
        const id = loginUser?.id;
        const {loading} = this.state;
        const labelWidth = 80;

        return (
            <ModalContent
                loading={loading}
                surplusSpace={false}
                onOk={() => this.form.submit()}
                onCancel={this.handleCancel}
            >
                <PageContent>
                    <Form ref={form => this.form = form} onFinish={this.handleOk} initialValues={{id}}>
                        <FormElement type="hidden" name="id"/>
                        <FormElement
                            label="原密码"
                            labelWidth={labelWidth}
                            type="password"
                            name="oldPassword"
                            required
                            autoFocus
                        />
                        <FormElement
                            label="新密码"
                            labelWidth={labelWidth}
                            type="password"
                            name="newPassword"
                            required
                            rules={[{validator: validateStrongPassword}]}
                        />
                        <FormElement
                            label="确认密码"
                            labelWidth={labelWidth}
                            type="password"
                            name="affirm_password"
                            dependencies={['newPassword']}
                            required
                            rules={[
                                ({getFieldValue}) => ({
                                    validator(rule, value) {
                                        if (!value || getFieldValue('newPassword') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject('新密码与确认新密码不同！');
                                    },
                                }),
                            ]}
                        />
                    </Form>
                </PageContent>
            </ModalContent>
        );
    }
}

